import { HttpClient } from '@angular/common/http';
import { ArmaServConnection } from '../info-connection';
import { Shape99InfoLine, ArmaRestOrderList, Formes, JsLineWMesh, JsLineDec, Grade } from '../json-interface';
import { g_params } from '../global-param';
import { CUtilit } from '../utilit';
import { CALC_VISIBILITY_COTE } from '../const';
import { CUtilForme } from '../info-forme';

/**Pas utilisé pour le moment */
export const MEMBER_TYPE = { ASS: 0, CF: 1, CL: 2, PROD: 3};

/**
 * Contiens les infos et les fonctions utilitaires pour une ligne de décorticage
 * Utiliser dans le tableau de décorticage
 */
export class CLineDec {

  private mIdLineDB: number = 0;    // Identifiant unique de la ligne sur armaor, 0 quand la ligne est crée sur le web

  mNoLine: string = '';                //
  mLongCoupe: string = '0';
  mLongClient: string = '0';
  mMachine1: string = '';      // Prod // NameMachine1
  mMachine2: string = '';
  mMachine3: string = '';
  Mach1: number = 0;          // Byte
  Mach2: number = 0;          // Byte
  Mach3: number = 0;          // Byte
  mBM: string = '';            // Rep
  mQty: string = '';           // Qteb
  //mDiam: string;          //
  mDiamNum: string = '';       // Info contenant seulement le chiffre dans le diametre
  mDiamGrade: string = '';     // Info contenant seulement le grade dans le diametre

  mCodeF: string = '';         // CodeForme
  mElem: number = 0;          //

  mPoidsCoupe: number = 0;
  mPoidsClient: number = 0;

  mMemberName: string = '';
  mMemberQty: number = 0;

  mArrayCote: string[] = [];           // Contiens les valeurs associé au input dans le html // Correspond au valeurs des cotations

  mSmallComment?: string = '';          //

  mInfoShape99: Shape99InfoLine[] = [];

  mRepartition: string | null = null;
  mFilantRepart: number = 0;
  mRepartCrochetLevage: boolean = false;

  private mErrorLineWeb?: string = '';  // Erreur sur la ligne recuperer depuis le serveur

  private mLastArrayErrorLine: string[] = []; //

  public wMeshInformation?: JsLineWMesh = undefined;

  /**
   * Interface contenant les infos de la derniere forme utilisé
   * Appeler la @function getShapeData() pour verifier & récuperer
   * la forme en fonction du code.
   */
  private mShapeData?: Formes = undefined;

  public static LoadFromArmaor(infoDataSnap: JsLineDec): CLineDec {
      const lineDec = new CLineDec();
      lineDec.loadFromjsLineDec(infoDataSnap);
      return lineDec;
  }

  constructor() {
      this.initValue();
  }

  private initValue() {
      this.mIdLineDB = 0;        // Default 0 si on la ligne est crée sur le web
      this.mNoLine = '';
      this.mLongCoupe = '0';  // TODO : Toujours util d'indiquer zero ici ?
      this.mLongClient = '0'; // TODO : Toujours util d'indiquer zero ici ?
      this.mMachine1 = '';
      this.mMachine2 = '';
      this.mMachine3 = '';
      this.Mach1 = 0;
      this.Mach2 = 0;
      this.Mach3 = 0;
      this.mBM = '';
      this.mQty = '';
      this.mDiamNum = '';
      this.mDiamGrade = '';
      this.mCodeF = '';
      this.mElem = 0;
      this.mSmallComment = '';
      this.mInfoShape99 = [];
      this.mPoidsCoupe = 0;
      this.mPoidsClient = 0;
      this.mMemberName = '';
      this.mMemberQty = 0;
      //this.mArrayInput = [];
      this.mArrayCote = [];
      this.mShapeData = undefined;
      this.mRepartition = null;
      this.mFilantRepart = 0;
      this.mRepartCrochetLevage = false;
      this.mErrorLineWeb = '';
      this.mLastArrayErrorLine = [];
      this.wMeshInformation = undefined;
  }

  public getDiametre(): string {
      let diam = '';
      if (this.mDiamNum) diam += this.mDiamNum;
      if (this.mDiamGrade) diam += this.mDiamGrade;
      return diam;
  }

  public loadFromjsLineDec(jsLineDec: JsLineDec, tryLoadMember: boolean = true, loadIdLine: boolean = true) {
      this.initValue();
      this.mNoLine = jsLineDec.NoLine;
      if (loadIdLine)
          this.mIdLineDB = jsLineDec.idLineDB;
      this.mElem = jsLineDec.Elem;
      this.mErrorLineWeb = jsLineDec.ErrorLine;
      this.mSmallComment = jsLineDec.SmallComment;

      // Affectation des infos lié à l'element
      if (tryLoadMember && jsLineDec.MemberInfo) {
          this.mMemberName = jsLineDec.MemberInfo.MemberName;
          this.mMemberQty = +jsLineDec.MemberInfo.MemberName;
      }

      if (jsLineDec.SteelLine) {
          // Affectation des infos lié à une ligne d'acier
          this.mCodeF = jsLineDec.SteelLine.CodeF;
          this.mShapeData = undefined;
          this.mArrayCote = [];
          jsLineDec.SteelLine.Cote.forEach(cote => this.mArrayCote.push((cote == '0') ? '' : cote));
          this.mInfoShape99 = jsLineDec.SteelLine.DataShape99;
          this.mDiamNum = jsLineDec.SteelLine.Diam.toString();
          this.mDiamGrade = jsLineDec.SteelLine.Grade;
          this.mLongClient = jsLineDec.SteelLine.Lgclient;
          this.mLongCoupe = jsLineDec.SteelLine.Lgcoupe;
          this.Mach1 = jsLineDec.SteelLine.Mach1;
          this.Mach2 = jsLineDec.SteelLine.Mach2;
          this.Mach3 = jsLineDec.SteelLine.Mach3;
          this.mMachine1 = jsLineDec.SteelLine.NameMach1;
          this.mMachine2 = jsLineDec.SteelLine.NameMach2;
          this.mMachine3 = jsLineDec.SteelLine.NameMach3;
          this.mPoidsClient = jsLineDec.SteelLine.PoidsClient;
          this.mPoidsCoupe = jsLineDec.SteelLine.PoidsCoupe;
          this.mQty = jsLineDec.SteelLine.Qteb.toString();
          this.mBM = jsLineDec.SteelLine.Rep;
      } else if (jsLineDec.RepartLine) {
          this.mRepartition = jsLineDec.RepartLine.Repartition;
          this.mFilantRepart = jsLineDec.RepartLine.FilantRepart;
          this.mRepartCrochetLevage = jsLineDec.RepartLine.RepartCrochetLevage;
      } else if (jsLineDec.ProductLine) {
          console.error('Product line on class CLineDec');
      } else if (jsLineDec.WMeshLine) {
          this.wMeshInformation = jsLineDec.WMeshLine ? Object.assign({}, jsLineDec.WMeshLine) : undefined;
      }
  }

  public update(newLineDec: CLineDec): any {
      this.mNoLine = newLineDec.mNoLine;
      this.mLongCoupe = newLineDec.mLongCoupe;
      this.mLongClient = newLineDec.mLongClient;
      this.mMachine1 = newLineDec.mMachine1;
      this.mMachine2 = newLineDec.mMachine2;
      this.mMachine3 = newLineDec.mMachine3;
      this.Mach1 = newLineDec.Mach1;
      this.Mach2 = newLineDec.Mach1;
      this.Mach3 = newLineDec.Mach1;
      this.mBM = newLineDec.mBM;
      this.mQty = newLineDec.mQty;
      this.mDiamGrade = newLineDec.mDiamGrade;
      this.mDiamNum = newLineDec.mDiamNum;
      this.mCodeF = newLineDec.mCodeF;
      this.mElem = newLineDec.mElem;
      this.mSmallComment = newLineDec.mSmallComment;
      this.mInfoShape99 = newLineDec.mInfoShape99 ? Object.assign([], newLineDec.mInfoShape99) : [];
      this.mPoidsCoupe = newLineDec.mPoidsCoupe;
      this.mPoidsClient = newLineDec.mPoidsClient;
      this.mMemberName = newLineDec.mMemberName;
      this.mMemberQty = newLineDec.mMemberQty;
      this.mShapeData = newLineDec.mShapeData;
      this.mRepartition = newLineDec.mRepartition;
      this.mFilantRepart = newLineDec.mFilantRepart;
      this.mRepartCrochetLevage = newLineDec.mRepartCrochetLevage;
      this.mErrorLineWeb = newLineDec.mErrorLineWeb;
      this.mLastArrayErrorLine = newLineDec.mLastArrayErrorLine;
      this.wMeshInformation = newLineDec.wMeshInformation ? Object.assign({}, newLineDec.wMeshInformation) : undefined;
  }

  public clearLine(clearMember: boolean) {
      const name = this.mMemberName;
      const qty = this.mMemberQty;
      const noLine = this.mNoLine;
      this.clearCotation();
      this.initValue();
      this.mNoLine = noLine;
      if (!clearMember) {
          this.mMemberName = name;
          this.mMemberQty = qty;
      }
  }

  /**
   * Vide le tableau de cotation
   * Vide aussi les poids & longueur
   */
  public clearCotation() {
      this.mArrayCote = [];
      this.mInfoShape99 = [];
      this.clearWeight();
      this.clearLenght();
  }

  public clearWeight() {
      this.mPoidsClient = 0;
      this.mPoidsCoupe = 0;
  }

  public clearLenght() {
      this.mLongClient = '';
      this.mLongClient = '';
  }

  public clearIdLine() {
      this.mIdLineDB = 0;
  }

  private zeroStringIfUndefined(val: any): string {
      return val ? val.toString() : '0';
  }

  public static isMeasureStrValid(measure: string): boolean {
    const DECIMAL_SEPARATOR_FR = ',';
    const DECIMAL_SEPARATOR_EN = '.';
    if (measure) {
      measure = measure.replace(' ', '');
      measure = measure.replace(DECIMAL_SEPARATOR_FR, DECIMAL_SEPARATOR_EN);
    }
    return !isNaN(+measure);
  }

  private getStringCote(): string[] {
    const stringCote: string[] = [];
    for (let i = 0 ; i < this.mArrayCote.length ; i++) {
      const strCote = this.mArrayCote[i];
      if (CLineDec.isMeasureStrValid(strCote))
        stringCote.push(strCote);
      else
        stringCote.push('0');
    }
    return stringCote;
  }

  public getWeight(decimal: number = 2): string {
      switch (this.cDecLineType) {
          case 'Shape':
          case 'Shape99':
              return this.mPoidsClient ? this.mPoidsClient.toFixed(decimal) : '';
          case 'WMesh':
              return this.wMeshInformation?.totalWeightRounded ? this.wMeshInformation?.totalWeightRounded.toFixed(decimal) : '';
          default:
              return '';
      }
  }

  public getOneLineLastErrorMessage(): string {
      let errorLine = '';
      if (this.mLastArrayErrorLine.length != 0) {
          for (let i = 0 ; i < this.mLastArrayErrorLine.length ; i++) {
              if (i != 0)
                  errorLine += ', ';
              errorLine += this.mLastArrayErrorLine[i];
          }
      }
      return errorLine;
  }

  public getLastArrayerrorMessage(): string[] {
      return this.mLastArrayErrorLine;
  }

  /**
   * Reourne un text indiquant l'erreur si la ligne saisie
   * Si la ligne est ok retourne vide
   * Pas d'erreur sur une ligne vide
   */
  public isLineValide(checkErrorWeb: boolean,             // Peut etre false pour cheque seulement les erreur que l'utilisateur a fait sur la ligne
                      arrayShapeAvailable: Formes[],      // Pour verifier la forme & les cotes
                      arrayDiameter: string[]): string {  // Pour verifier si le diametre saisie existe
      /**
       * Sous fonction pour savoir si le diametre est valide ou non
       * @param diameter string
       * @returns boolean
       */
      function diameterValide(diameter: string): boolean {
          if (arrayDiameter && arrayDiameter.length > 0) {
              for (let i = 0 ; i < arrayDiameter.length ; i++) {
                  if (diameter == arrayDiameter[i])
                      return true;
              }
          }
          return false;
      }

      this.mLastArrayErrorLine.length = 0; // Reinit de la derniere erreur recuperer

      // Pas de pb si la ligne est vide
      if (this.isEmpty())
          return '';

      if (checkErrorWeb) {
          // Check si le web nous a retournée une erreur
          if (this.mErrorLineWeb)
              this.mLastArrayErrorLine.push(this.mErrorLineWeb);
      }

      // Verification suivant les different type de ligne
      if (this.isAShape() || this.isAShape99()) { // Ligne acier
          if (!this.mQty)
              this.mLastArrayErrorLine.push('Wrong qty');
          else if (!this.getDiametre() || !diameterValide(this.mDiamNum))
              this.mLastArrayErrorLine.push('Wrong diameter');
          else if (!this.mCodeF)
              this.mLastArrayErrorLine.push('Wrong shape code');
          else if ((this.isAShape()) && (this.hasEmptyWritedInput(arrayShapeAvailable)))
              this.mLastArrayErrorLine.push('Wrong measure');
          else if ((this.isAShape99()) && (this.mInfoShape99.length == 0))
              this.mLastArrayErrorLine.push('Shape 99 measure empty');
      }
      // Le tableau en une ligne
      return this.getOneLineLastErrorMessage();
  }

  /**
   * Recuperer la forme associé au décorticage & verifie si on à une cote saisie vide
   * @param arrayShapeAvailable Liste des formes disponible sur le web
   * @returns true si ligne vide sinon false
   */
  private hasEmptyWritedInput(arrayShapeAvailable: Formes[]): boolean {
      const shape: Formes | undefined = this.getOrFindShapeData(arrayShapeAvailable);
      if (!shape) return true; // True si impossible de recup la forme
      for (let index = 0; index < shape.Cote.length; index++) {
          const element = shape.Cote[index];
          if (+element.Calc == CALC_VISIBILITY_COTE.ALWAS_VISIBLE &&
              (this.mArrayCote[index] == '' || this.mArrayCote[index] === undefined || !this.mArrayCote[index])) {
              return true;
          }
      }
      return false; //
  }

  /**
   * Passe la ligne en cours au serveur web pour qu'il puisse calculer le poids & la longueure de la piece
   * Forme clasique & shape99
   * @param http HttpClient
   * @param arrayShape liste des formes disponible
   */
  public async refreshLineArmaWeb(http: HttpClient, arrayShape: Formes[]) {
      console.log('refreshLineArmaWeb');
      const lineresult: JsLineDec = ((await ArmaServConnection.aPOST(http, 'CalcLine', this.toJsLineDec(true), [])).result[0] as JsLineDec);
      if (lineresult.SteelLine) {
          if (lineresult.SteelLine.Lgclient == undefined || lineresult.SteelLine.Lgclient == '0')
              console.warn('Unable to calculate lenght');
          if (lineresult.SteelLine.PoidsClient == 0)
              console.warn('Unable to calculate weight');
          //this.loadFromDataSnap(lineresult, true);  // Ne pas refresh la ligne entiere car on peut perdre les information des cote si on est toujours en saisie
          // On refrsh les poids
          this.mPoidsClient = lineresult.SteelLine.PoidsClient;
          this.mPoidsCoupe = lineresult.SteelLine.PoidsCoupe;
          // On refrehs les longueurs
          this.mLongClient = lineresult.SteelLine.Lgclient;
          this.mLongCoupe = lineresult.SteelLine.Lgcoupe;
          // Refresh de la forme utilisé
          const forme = CUtilit.findShape(this.mCodeF, arrayShape);
          if (forme) {
              for (let i = 0; i < forme.Cote.length; i++) {
                  // On enregistre les valeur calculer de la forme
                  if (+forme.Cote[i].Calc != CALC_VISIBILITY_COTE.ALWAS_VISIBLE) {
                      this.mArrayCote[i] = lineresult.SteelLine.Cote[i];
                  }
              }
          }
      }
      // Refresh elem
      this.mElem = lineresult.Elem;
      this.mErrorLineWeb = lineresult.ErrorLine;
  }

  public isCoteLocked(shapes: Formes[], idCote: number): boolean {
      if (!idCote || idCote < 0) return false; // Si pas de cote alors pas de lock
      if (this.isAShape99()) return true; // Pas de cote afficher sur la forme 99
      const forme: Formes | undefined = this.getOrFindShapeData(shapes); // Recup de la forme
      if (!forme || forme === undefined) return true; // Lock si la forme n'existe pas
      return CUtilForme.isCalculatedMeasure(forme, idCote);
  }

  /**
   * Retourne l'interface forme de la ligne
   * Recherche & stoque l'interface si pas renseigné
   * retourne undefined si le code forme ne correspond pas
   * @param shapes array de forme à utiliser pour rechercher la forme
   * @returns interface de la forme ou undefined
   */
  public getOrFindShapeData(shapes: Formes[]): Formes | undefined {
      if (this.isAShape99()) return undefined;
      if (this.mCodeF == '') return undefined;
      // Recharge de l'interface forme si pas d'interface ou code forme différent de celui de l'interface
      if (!this.mShapeData || this.mShapeData.CodeForme != this.mCodeF)
          this.mShapeData = CUtilit.findShape(this.mCodeF, shapes);
      return this.mShapeData;
  }

  public toJsLineDec(getMember: boolean = true): JsLineDec {
      const result: JsLineDec = {
          Elem: this.mElem,
          ErrorLine: this.mErrorLineWeb,
          NoLine: this.mNoLine,
          idLineDB: this.mIdLineDB,
          SmallComment: this.mSmallComment,
      };

      if (getMember && this.mMemberName != '') {
          result.MemberInfo = {
              MemberName: this.mMemberName,
              MemberQty: this.mMemberQty.toString(),
          };
      }

      if (this.isAShape() || this.isAShape99()) {
          result.SteelLine = {
              CodeF: this.mCodeF,
              Cote: this.getStringCote(),
              DataShape99: this.mInfoShape99,
              Diam: this.mDiamNum ? +this.mDiamNum : 0,
              Grade: this.mDiamGrade,
              Lgclient: this.mLongClient,
              Lgcoupe: this.mLongCoupe,
              Mach1: this.Mach1,
              Mach2: this.Mach2,
              Mach3: this.Mach3,
              NameMach1: this.mMachine1,
              NameMach2: this.mMachine2,
              NameMach3: this.mMachine3,
              PoidsClient: this.mPoidsClient,
              PoidsCoupe: this.mPoidsCoupe,
              Qteb: this.mQty ? +this.mQty : 0,
              Rep: this.mBM
          };
      } else if (this.isARepartition()) {
          result.RepartLine = {
              Repartition: this.mRepartition || '',
              FilantRepart: this.mFilantRepart ?? 0,  //Si null alors 0
              RepartCrochetLevage: this.mRepartCrochetLevage
          };
      } else if (this.isAWMesh) {
          result.WMeshLine = this.wMeshInformation;
      }
      return result;
  }

  public getNbCadres(): number {
      let cadres = -1;
      if (this.isARepartition() && this.mRepartition) {
          const splitRepart: string[] = this.mRepartition.split('/');
          splitRepart.forEach(repart => {
              const multiplication: string[] = repart.split('*');
              if (multiplication.length > 1)
                  cadres += parseInt(multiplication[0], 10);
              else
                  cadres++;
          });
      }
      return cadres;
  }

  //////////////////////////////////////

  public clearMemberInfo() {
      this.mMemberName = '';
      this.mMemberQty = 0;
  }

  public clearShapeInfo() {
      this.mCodeF = '';
      this.mArrayCote = [];
      this.mInfoShape99 = [];
  }

  public clearRepartInfo() {
      this.mRepartition = null;
  }

  public clearWMeshInfo() {
      this.wMeshInformation = undefined;
  }

  public clearAll(clearMember: boolean) {
      if (clearMember)
          this.clearMemberInfo();
      this.clearShapeInfo();
      this.clearRepartInfo();
      this.clearRepartInfo();
      this.clearWMeshInfo();
  }

  public setTypeWMesh(meshInformation: JsLineWMesh) {
      this.clearAll(false);
      this.wMeshInformation = meshInformation;
  }

  public get hasMember(): boolean { return !!this.mMemberName && (this.mMemberName != ''); }

  //////////////////////////////////////////

  public isAShape(): boolean {
      return (this.mCodeF !== undefined) && (this.mCodeF != g_params.shapeCode99) && (this.mCodeF != '');
  }

  public isAShape99(): boolean {
      return g_params.shapeCode99 == this.mCodeF;
  }

  public isARepartition(): boolean {  // mRepartion = "" reste une ligne de repartition
      return this.mRepartition != null && this.mRepartition != undefined;
  }

  public isEmpty(): boolean {
      return (
          !this.isAShape() &&
          !this.hasMember &&
          !this.isAShape99() &&
          !(this.isARepartition() && this.mRepartition != '') &&
          !this.isAWMesh
      );
  }

  public get isAWMesh(): boolean {
    return this.wMeshInformation !== undefined;
  }

  /** Type de ligne affiché dans le html */
  get cDecLineType(): CDecLineType {
      if (this.isARepartition())
          return 'Distribution';
      else if (this.isAShape())
          return 'Shape';
      else if (this.isAShape99())
          return 'Shape99';
      else if (this.isAWMesh)
          return 'WMesh';
      return 'Empty';
  }
}

type CDecLineType = 'Empty'|'Distribution'|'Shape'|'Shape99'|'WMesh';

/** Correspond au donnée que l'on envoi vers armaserv pour faire la sauvegarde du décorticage */
export interface JSSteelList {
    'InfoSteelList': ArmaRestOrderList;
    'Data': JsLineDec[];
}

export class GradeManager {
    public mArrayGrade: Grade[];

    constructor(arrayGrade: []) {
        this.mArrayGrade = arrayGrade;
    }

    public GetArrayDiameter(gradeCode?: String): string[] {
        const arrayDiam: string[] = [];

        this.mArrayGrade.forEach(grade => {
            //Si on a pas passé de gradeCode OU si le gradeCode donné correspond à celui testé
            if (!gradeCode || (grade.Code == gradeCode)) {
                grade.DiameterAvailable.forEach(diam => {
                    //Le diamètre n'est pas présent dans la liste
                    if (arrayDiam.indexOf(diam.toString()) == -1) {
                        arrayDiam.push(diam.toString());
                    }
                });
            }
        });
        //Tri des diamètres
        arrayDiam.sort( (a: string, b: string) => (+a) - (+b));
        return arrayDiam;
    }

    public GetArrayGrade(diameter?: number): Grade[] {
        let arrayGrade: Grade[] = [];

        if (!diameter) {
            arrayGrade = this.mArrayGrade;
        } else {
            this.mArrayGrade.forEach(grade => {
                if (grade.DiameterAvailable.indexOf(diameter) != -1) {
                    arrayGrade.push(grade);
                }
            });
        }

        return arrayGrade;
    }

    public async LoadGrades(http: HttpClient) {
        //Revoir le chargement
        if (this.mArrayGrade.length == 0) {
            this.mArrayGrade = (await ArmaServConnection.aGET(http, 'GetAllGrade')).result[0];
        }
    }

    public static separateDiamGrade(diamGrade: string): {diam: number, grade: string} {
        let diam = '';
        let grade = '';
        let finDiam = false;
        for (let i = 0 ; i < diamGrade.length ; i++) {
            const castNumber: number = +diamGrade[i];
            if (!finDiam && !isNaN(castNumber)) {
                diam += diamGrade[i];
            } else {
                finDiam = true;
                grade += diamGrade[i];
            }
        }
        return {
            diam: +diam,
            grade: grade
        };
    }

    /**
    * Retourne la nuance par default pour le diametre saisie.
    * Si le diametre n'existe pas dans la nuance, alors retourne la premiere nuance qui dispose de ce diameter
    * @param arrayGrade ??
    */
    public static getGradeFromDiam(diameter: number, arrayGrade: Grade[]): { found: boolean, gradeCode: string, isDefaultGrade: boolean} {
        let gradeFound = false;
        let defaultGradeFound = false;
        let gradeCode = '';
        // On boucle sur toute les nuance disponible
        for (let i = 0 ; i < arrayGrade.length ; i++) {
            const isDefaultGrade = arrayGrade[i].Default == 1;
            let isGradeOK = false;

            // On boucle encore sur tout les diametre disponible pour verifier si le diametre est possible
            for (let j = 0 ; j < arrayGrade[i].DiameterAvailable.length ; j++) {
                isGradeOK = diameter == arrayGrade[i].DiameterAvailable[j];
                if (isGradeOK)
                    break;
            }

            if (isGradeOK) {
                gradeFound = true;
                if (isDefaultGrade)
                    defaultGradeFound = true;
                // On enregistre le premier grade trouvé ou le grade par default trouvé
                if (gradeCode == '' || defaultGradeFound)
                    gradeCode = arrayGrade[i].Code;
            }

            if (defaultGradeFound)
                break;
        }

        return {
            found: gradeFound,
            gradeCode: gradeCode,
            isDefaultGrade: defaultGradeFound
        };
    }

}
